import React, { useState } from "react";
import { Row, Col, Flex, Select } from "antd";
import { observer } from "mobx-react-lite";
import AddEmployeeBtn from "../../components/employees/buttons/AddEmployeeBtn";
import CreatePayroll from "../../components/employees/buttons/CreatePayroll";
import ViewSalaryBtn from "../../components/employees/buttons/ViewSalaryBtn";
import { ArrowDownOutlined } from "@ant-design/icons";
import EmployeeDashboard from "../../components/employees/cards/EmployeeDashboard";
import EmployeeCards from "../../components/employees/cards/EmployeeCards";
import LoadingScreen from "../../components/common/LoadingScreen";
import { useEmployee } from "../../app/hooks/useEmployee";
import { useDepartment } from "../../app/hooks/useDepartment";
import { useCurrentUser } from "../../app/hooks/useCurrentUser";

import { useStore } from "../../app/stores/store";

const Employees = () => {
  const [selectedDepartment, setSelctedDepartment] = useState();
  const [searchDepartments, setSearchDepartments] = useState([]);
  const { employeeStore } = useStore();
  const { searchEmployeeResults } = employeeStore;
  const { role } = useCurrentUser();

  const {
    isLoading,
    data,
    mutate,
  } = useEmployee({
    departmentId: selectedDepartment ?? "",
    pageNumber: 0,
    pageSize: 9999,
  });
  const { data: departmentList, find } = useDepartment();



  return (
    <div className="employees-container">
      <EmployeeDashboard />
      <Row style={{ width: "100%" }} justify={"space-between"}>
        <Col>
          <h2 style={{ fontWeight: "bold" }}>List of Employees</h2>
        </Col>
        <Col>
          <Flex style={{ marginTop: 20 }} justify={"flex-end"}>
            <Row gutter={16}>
              <Col>
                <CreatePayroll
                  onSubmit={() => {
                    mutate();
                  }}
                />
              </Col>
              <Col>
                <ViewSalaryBtn
                  onSubmit={() => {
                    mutate();
                  }}
                />
              </Col>
              {role.includes("Accounting") ? null : (
                <Col>
                  <AddEmployeeBtn
                    onSubmit={() => {
                      mutate();
                    }}
                  />
                </Col>
              )}

              <Col>
                <Select
                  allowClear
                  showSearch
                  type="primary"
                  className="department-dropdown"
                  value={selectedDepartment}
                  style={{ marginLeft: 10, width: 200 }}
                  placeholder="Search Department"
                  bordered={false}
                  onChange={(value) => {
                    if (value !== selectedDepartment)
                      setSelctedDepartment(value);
                  }}
                  onSearch={async (value) => {
                    if (value.trim() !== "") {
                      const res = await find(value);
                      setSearchDepartments(res); // update local state
                    } else {
                      mutate(); // reset to all departments
                      setSearchDepartments([]); // clear custom search result
                    }
                  }}
                  suffixIcon={
                    <ArrowDownOutlined style={{ color: "#ffffff" }} />
                  }
                  filterOption={false}
                  notFoundContent={null}
                  options={(Array.isArray(searchDepartments) &&
                  searchDepartments.length > 0
                    ? searchDepartments
                    : Array.isArray(departmentList)
                    ? departmentList
                    : []
                  ).map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))}
                />
              </Col>
            </Row>
          </Flex>
        </Col>
      </Row>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <EmployeeCards
          data={searchEmployeeResults.length > 0 ? searchEmployeeResults : data}
          onSubmit={() => {
            mutate();
          }}
        />
      )}
    </div>
  );
};

export default observer(Employees);
